import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { ComposedSupplierResolver } from '@shared/resolvers';
import { AuthenticationGuard, LanguageIdGuard } from '@shared/guards';
import { CheckoutContainer } from './containers';
import { CreditBundlesResolver, QuoteResolver } from './resolvers';
import { CreditBalanceResolver } from '../account/resolvers';

const routes: Routes = [
  {
    path: ':languageId',
    component: CheckoutContainer,
    canActivate: [AuthenticationGuard, LanguageIdGuard],
    canActivateChild: [AuthenticationGuard],
    data: {
      title: 'Purchase Credits'
    },
    children: [
      {
        path: 'payments',
        loadChildren: () => import('./modules/payment-add-credits/payment-add-credits.module').then(m => m.CheckoutPaymentModule)
      },
      /* PATH FOR QUOTE CREATION  - NOT ENOUGH CREDITS */
      {
        path: 'quote/:quoteId',
        loadChildren: () => import('./modules/quote/quote.module').then(m => m.CheckoutQuoteModule),
        resolve: { quote: QuoteResolver }
      },
      /* PATH FOR QUOTE LIST  - NOT SEND QUOTE */
      {
        path: 'quote-list/:quoteId',
        loadChildren: () => import('./modules/quote-list/quote-list.module').then(m => m.CheckoutQuoteListModule),
        resolve: { quote: QuoteResolver }
      },
      {
        path: 'special-bundle',
        loadChildren: () => import('./modules/special-bundle/special-bundle.module').then(m => m.CheckoutSpecialBundleModule)
      }
    ],
    resolve: {
      supplier: ComposedSupplierResolver,
      creditBundles: CreditBundlesResolver,
      creditBalance: CreditBalanceResolver
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CheckoutRoutingModule {}
